// extracted by mini-css-extract-plugin
export default {"bubble":"Bubble_bubble__4LoGn"};